import cn from 'classnames'
import React from 'react'
import LazyLoad from 'react-lazy-load'
import config from '../../config.json'

const PreviewGraphic = ({ collection, size, hash }) => {
    return (
        <LazyLoad offset={100} className={cn('h-16 xl:h-20 w-16 xl:w-20 flex')}>
            {hash ? (
                <img
                    className={cn(
                        'max-w-16 xl:max-w-20 h-auto w-auto max-h-16 xl:max-h-20 m-auto',
                    )}
                    src={config.ipfspreviewhash
                        .replace('{collection}', collection)
                        .replace('{size}', size)
                        .replace('{hash}', hash)}
                    width={240}
                    height={240}
                    alt="img"
                />
            ) : (
                <div />
            )}
        </LazyLoad>
    )
}

export default PreviewGraphic
